import { BitmapText, Container, PointData, Text } from "pixi.js";
import { Game } from "./Game";
import { ITransform } from "./ITransform";
import { Geom } from "./Geom";

export class DamageTick implements ITransform {
	private readonly text: BitmapText;
	private maxDuration: number = 1400;
	private duration: number = this.maxDuration;
	private speed: number = 0.05;

	public constructor(parent: Container, position: PointData, amount: number) {
		this.text = new BitmapText({
			text: amount.toString(),
			anchor: {x: 0.5, y: 0.5},
			style: {
				fontSize: 16,
				fontWeight: 'bold',
			},
			position
		});
		parent.addChild(this.container);
	}

	public tick(deltaMS: number, game: Game) {
		this.duration -= deltaMS;
		this.y -= deltaMS * this.speed;
		if (this.duration < this.maxDuration - 400) {
			this.text.alpha = Geom.lerp(this.duration, 0, this.maxDuration - 400);
		}
		if (this.duration < 0) {
			this.text.removeFromParent();
			this.text.destroy();
		}
	}

	// region ITransform

	public get container(): Container {
		return this.text;
	}

	public get x(): number {
		return this.container.x;
	}

	public set x(value: number) {
		this.container.x = value;
	}

	public get y(): number {
		return this.container.y;
	}

	public set y(value: number) {
		this.container.y = value;
	}

	public get w(): number {
		return this.container.width;
	}

	public get h(): number {
		return this.container.height;
	}

	// endregion
}
